import React from "react";
import { BadgeCheck } from "lucide-react";
import { formatSubscriptionDate } from "./subscriptionUtils";

const PlanCard = ({ subscription, isLoading, isError }) => {
  if (isLoading) {
    return <div className="plan-card plan-card--highlight">Loading subscription...</div>;
  }

  if (isError) {
    return (
      <div className="plan-card plan-card--highlight">
        Error occurred while fetching subscription data.
      </div>
    );
  }

  const plan = subscription?.plan;
  const isActive =
    subscription?.status === "active" ||
    subscription?.status === "trial" ||
    subscription?.isActive === true ||
    plan?.isActive === true;
  const isPaid =
    plan?.type === "paid" ||
    subscription?.paymentStatus === "paid" ||
    subscription?.isPaid === true;

  const ownerType = subscription?.ownerType || subscription?.owner?.type || "company";
  const nextBilling = formatSubscriptionDate(
    subscription?.nextBillingDate ||
      subscription?.nextBilling ||
      subscription?.billingDate ||
      subscription?.nextPaymentDate ||
      subscription?.endDate ||
      subscription?.trialEndDate
  );
  const billingFrequency =
    subscription?.billingFrequency ||
    subscription?.billingCycle ||
    plan?.billingCycle ||
    plan?.billingFrequency ||
    plan?.duration ||
    "monthly";

  return (
    <div className="plan-card plan-card--highlight">
      <div className="plan-header">
        <div className="plan-left">
          <div className="plan-icon">
            <BadgeCheck size={26} />
          </div>

          <div>
            <h2>{plan?.name || subscription?.planName || "No plan selected"}</h2>
            <p>{plan?.description || subscription?.usageMessage || "Choose a subscription plan to get started."}</p>
          </div>
        </div>

        <div className="plan-status">
          <span className={`active-badge ${isActive ? "" : "inactive"}`}>
            ● {isActive ? "Active" : "Inactive"}
          </span>
          <span className={`paid-badge ${isPaid ? "" : "unpaid"}`}>
            {isPaid ? "Paid" : "Unpaid"}
          </span>
        </div>
      </div>

      <div className="plan-footer">
        <div>
          <p>OWNER TYPE</p>
          <h4>{ownerType}</h4>
        </div>

        <div>
          <p>NEXT BILLING</p>
          <h4>{nextBilling || "—"}</h4>
        </div>

        <div>
          <p>BILLING FREQUENCY</p>
          <h4>{billingFrequency}</h4>
        </div>
      </div>
    </div>
  );
};

export default PlanCard;
